// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  deviceId: __t.u64().primaryKey().name("device_id"),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  kind: __t.string(),
  name: __t.string(),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  yaw: __t.f32(),
  sx: __t.f32(),
  sy: __t.f32(),
  sz: __t.f32(),
  configJson: __t.string().name("config_json"),
  enabled: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
